import { useSelector } from "react-redux";
import { TitleContainer } from "../styled/common";

export default function HomepageNotice({ message = [] }) {
  const setting = useSelector((state) => state?.user?.setting);

  const parseMessage = (text, index) => {
    const parts = text.split(/(\*\*[^*]+\*\*)/g);
    return (
      <span key={index}>
        {parts.map((part, i) =>
          part.startsWith("**") && part.endsWith("**") ? (
            <strong key={i}>{part.slice(2, -2)}</strong>
          ) : (
            part
          ),
        )}
      </span>
    );
  };

  return <TitleContainer className={setting?.mode}>{message.map(parseMessage)}</TitleContainer>;
}
